module.exports = __webpack_public_path__ + "static/CTPAT-e283b132af86188ea435d480f7ac283b.png";